import { LOG_MODEL_KEY_POINTER } from 'models/daos/log/constants'

const LOGS_DOMAIN = 'logs'
const LOGS_STATE = {
  all: {
    data: [],
    status: null
  },
  data: {}
}

const LOGS_DOMAIN_MAP_KEY = LOG_MODEL_KEY_POINTER

export {
  LOGS_DOMAIN,
  LOGS_DOMAIN_MAP_KEY,
  LOGS_STATE
}
